import { Filter, FilterService } from './Filter';
import { getTotalAudience } from '../assets/libs/broox/brooxCloudApi';
import { ChartInput } from './ChartInput';
import { AccountParams } from './AccountParams';

interface Audience {
  traffic: number,
  views: number,
  dwell: number,
  attention: number,
  gender: ChartInput,
  age: ChartInput,
  emotion: ChartInput
}

const getAudience = async (filter: Filter, params: AccountParams): Promise<Audience> => {
  filter = FilterService.parse(filter);
  const genderColors = { Female: '#00E99B', Male: '#1ACBE6' };
  const ageData = { 'Children (0-20)': { color: '#EDE2FF', label: '<20'}, 'Young (21-40)': { color: '#FFA16C', label: '21-40' }, 'Middle Age (41-60)': { color: '#1ACBE6', label: '41-60' }, 'Elder (61-99)': { color: '#A162F7', label: '>60' }};
  const emotionColors = { calm: '#1ACBE6', happy: '#ACEAF7', surprise: '#FF8744', anger: '#A162F7', sad: '#81E9B4' };
  // filter.cutoff (CX-638 §05) no llega aquí: getTotalAudience delega en el
  // bundle vendorizado brooxCloudApi.js, cuyo parseFilter interno fuerza
  // endOf('day') sin ninguna forma de override. Arreglarlo exige que el
  // backend de la API cloud acepte un corte horario — fuera del alcance de
  // este repo.
  const data: any = await getTotalAudience(filter, params.host, params.token || params.id, params.apiKey);
  const result: Audience = {
    traffic: data.traffic.count || 0,
    views: data.views.count || 0,
    dwell: data.dwell.average || 0,
    attention: data.attention.average || 0,
    gender: { datasets: [{ data: [], backgroundColor: [] }], labels: [] },
    age: { datasets: [{ data: [], backgroundColor: [], barThickness: 20, borderRadius: 15, borderSkipped: false, minBarLength: 12 }], labels: [] },
    emotion: { datasets: [], labels: [] }
  };
  let sum = data.gender.reduce((accumulator: number, current: any) => accumulator + current.value, 0);
  for(let d of data.gender) {
    result.gender.labels.push(d.label || '');
    const value = (d.value / sum * 100).toFixed(1);
    const genderData = result.gender.datasets[0].data as { value: number | string, label: string }[];
    genderData.push({ value: value, label: value + '%' });
    const label = d.label as keyof typeof genderColors;
    const backgroundColors = result.gender.datasets[0].backgroundColor as string[];
    backgroundColors.push(genderColors[label]);
  }
  sum = data.age.reduce((accumulator: number, current: any) => accumulator + current.value, 0);
  for(let d of data.age) {
    const label = d.label as keyof typeof ageData;
    result.age.labels.push(ageData[label].label);
    const value = (d.value / sum * 100).toFixed(1);
    const ageValues = result.age.datasets[0].data as { value: number | string, label: string, x?: string }[];
    ageValues.push({ x: ageData[label].label, value: Number(value), label: value + '%' });
    const backgroundColors = result.age.datasets[0].backgroundColor as string[];
    backgroundColors.push(ageData[label].color);
    result.age.datasets[0].parsing = { yAxisKey: 'value', xAxisKey: 'x' };
  }
  for(let d of data.emotion) {
    const label: keyof typeof emotionColors = d.label as keyof typeof emotionColors;
    const dataset = {
      data: [{ x: 0, y: 0, r: d.value }],
      label: d.label,
      backgroundColor: emotionColors[label]
    }
    result.emotion.datasets.push(dataset);
  }
  return result;
}

const getPreviousAudience = async (filter: Filter, params: AccountParams): Promise<Audience> => {
  filter = FilterService.parse(filter);
  filter = FilterService.previous(filter);
  return await getAudience(filter, params);
}

export { Audience, getAudience, getPreviousAudience };